
  import {
    Vue,
    Component,
    Watch,
    Ref,
    Prop,
  } from 'vue-property-decorator';
  import {
    Dialog,
    Button,
    Row,
    Col,
    Form,
    FormItem,
    Input,
    Select,
    Option,
    Table,
    TableColumn,
    InputNumber,
    Card,
    Checkbox,
    RadioGroup,
    Radio,
  } from 'element-ui';
  import {
    log,
  } from 'util';
  import api from '@/api/app';
  import examApi from '@/api/exam';
  import addOrModifyCommon from "../../../../components/common/addOrModifyCommon.vue";
  import {COMMON_DATA_TYPE} from "../../../../../../libs/config";
  @Component({
    components: {
      Dialog,
      Button,
      Row,
      Col,
      addOrModifyCommon,
      Form,
      FormItem,
      Input,
      Select,
      Option,
      Table,
      TableColumn,
      InputNumber,
      Card,
      Checkbox,
      RadioGroup,
      Radio,
    },
  })
  export default class paperDetail extends Vue {
    // 单选题列表
    private radioList: any = [];

    private radioListItems: any = []

    // 多选题列表
    private multList: any = [];

    private multListItems: any = []

    // 判断题列表
    private judgeList: any = [];

    private judgeListItems: any = []

    mounted() {
      console.log(this.$route.params.pid);
      examApi.getpaperDetailCount(this.$route.params.pid).then((res: any) => {
        this.radioList = res.filter(item => { return item.prefix === '一'})
        this.radioListItems = this.radioList[0].items
        this.multList = res.filter(item => { return item.prefix === '二'})
        this.multListItems = this.multList[0].items
        this.judgeList = res.filter(item => { return item.prefix === '三'})
        this.judgeListItems = this.judgeList[0].items
        // console.log(this.radioList[0].items[0].title);
        console.log(this.multList[0].items)
      })
    }
    }
